const mutations = {
  setDriverDetails(state, payload) {
    state.driver.assessmentId = payload.assessmentId;
    state.driver.driverId = payload.driverId;
    state.driver.pcoNumber = payload.pcoNumber;
    state.driver.dvlaNumber = payload.dvlaNumber;
  },
  resetStore(state) {
    state.driver.assessmentId = '';
    state.driver.driverId = '';
    state.driver.pcoNumber = '';
    state.driver.dvlaNumber = '';
    state.theoryAnswers = {};
  },
};

const getters = {
  getDriverId(store) {
    return store.driver.driverId;
  },
  getDriver(store) {
    return store.driver;
  },
};

const actions = {
  setDriverDetails({ commit }, payload) {
    commit('setDriverDetails', payload);
  },
  resetStore({ commit }) {
    commit('resetStore');
  },
};

const state = () => ({
  driver: {
    assessmentId: '',
    driverId: '',
    pcoNumber: '',
    dvlaNumber: '',
  },
  theoryAnswers: {},
});

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
